import { getApiBaseUrl } from '../../../utils/environment.mjs';
import axios from 'axios';

const API_URL = getApiBaseUrl()
// In signupService.mjs - no changes needed, but you can add better error handling
export const signupService = async (userData) => {
    try {
        
        
        const response = await axios.post(`${API_URL}/auth/signup`, userData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data.message || 'Failed to sign up');
        } else if (error.request) {
            throw new Error('No response from server. Please try again later.');
        } else {
            throw new Error('Error setting up request: ' + error.message);
        }
    }
};